import { css } from 'emotion'

export const TasksWatcherStyles = css``
